import { useFormContext } from "react-hook-form"
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form"
import { RequiredMark } from "./required-mark"
import { Textarea } from "../ui/textarea"

interface FormTextareaFieldProps {
  name: string
  label?: string
  placeholder?: string
  required?: boolean
  rows?: number
  className?: string
}

export function FormTextareaField({
  name,
  label,
  placeholder,
  required,
  rows = 4,
  className,
}: FormTextareaFieldProps) {
  const { control } = useFormContext()

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          {label && (
            <FormLabel className="text-gray-200 text-sm font-semibold">
              {label}
              {required && <RequiredMark />}
            </FormLabel>
          )}
          <FormControl>
            <div className="border border-gray-700 rounded-lg hover:border-gray-600 focus-within:border-purple-500 transition-colors">
              <Textarea
                rows={rows}
                placeholder={placeholder}
                className="bg-transparent border-none outline-none text-gray-300 text-sm font-normal w-full leading-relaxed resize-none placeholder:text-gray-600"
                {...field}
              />
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}